import { render, staticRenderFns } from "./gasData.vue?vue&type=template&id=6aac3964&scoped=true"
import script from "./gasData.vue?vue&type=script&lang=js"
export * from "./gasData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aac3964",
  null
  
)

export default component.exports